module.exports = __webpack_public_path__ + "img/er.2be2e315.svg";